export default {
  OK: "ok",
  ALARM: "alarm"
};
